module.exports = __webpack_public_path__ + "img/pass@2x (1).3ae0584e.png";